import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 16v-2h2.75l-.4-.35c-.867-.767-1.475-1.642-1.825-2.625A8.816 8.816 0 0 1 0 8.05C0 6.2.554 4.554 1.663 3.112 2.77 1.671 4.216.717 6 .25v2.1a5.928 5.928 0 0 0-2.9 2.212A5.918 5.918 0 0 0 2 8.05c0 .75.142 1.48.425 2.188.283.708.725 1.362 1.325 1.962l.25.25V10h2v6H0Zm10-.25v-2.1a5.928 5.928 0 0 0 2.9-2.213A5.919 5.919 0 0 0 14 7.95c0-.75-.142-1.48-.425-2.188-.283-.708-.725-1.362-1.325-1.962L12 3.55V6h-2V0h6v2h-2.75l.4.35c.817.817 1.412 1.704 1.787 2.663.376.958.563 1.937.563 2.937 0 1.85-.554 3.496-1.662 4.937-1.109 1.442-2.555 2.396-4.338 2.863Z" }, null, -1)
  ])))
}
export default { render: render }